/** Convert cents to euros */
export function centsToEuros(cents: number): number {
  return cents / 100
}

/** Format a number as EUR currency for French locale (e.g. "12,50 €") */
export function formatPrice(value: number): string {
  return new Intl.NumberFormat('fr-FR', {
    currency: 'EUR',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: 'currency',
  }).format(value)
}

/** Format a number with 2 decimal places using comma separator (e.g. "12,50") — no currency symbol */
export function formatPriceRaw(value: number): string {
  return value.toFixed(2).replace('.', ',')
}
